import React from 'react'

import { Link } from 'react-router-dom'
import { useLogin } from 'hooks/auth'
import { useForm } from 'react-hook-form'
import { DASHBOARD, REGISTER } from 'lib/routes'
import TreePilotLoading from '../TreePilotLoading'
import 'stylesheets/Login/Login.css'
import { Icon } from '@iconify/react';
import loginImage from 'imgs/login-2.jpg'
import treePilotLogo from 'imgs/TreepilotLogo.png'
import ButtonWithLoading from 'components/MainComponents/ButtonWithLoading/ButtonWithLoading'
import { useState } from 'react'

const Login = () => {
    const [showPassword, setShowPassword] = useState(false)
    const { login, isLoading, userLoading } = useLogin()
    const {
        register,
        handleSubmit,
        reset,
    } = useForm()

    async function handleLogin(data) {
        const succeeded = await login({
            email: data.email,
            password: data.password,
            redirectTo: DASHBOARD,
        })
        if (succeeded) reset()
    }

    if (userLoading) return (<TreePilotLoading />)

    const handleShowPassword = ()=>{
        setShowPassword(!showPassword)
    }


    return (
        <div className='login-main-container'>
            <div className="side-left">
                <div className="side-left-content">
                    <img className='logo' src={treePilotLogo} alt="" />
                    <h2>Inicia Sesión a tu Cuenta</h2>
                    <p className='subtitle'>Bienvenido de nuevo! Introduce tu correo y contraseña:</p>
                    <form onSubmit={handleSubmit(handleLogin)}>
                        <div className="input-container">
                            <Icon className='icon' icon="line-md:email" />
                            <input autoComplete='off' placeholder='Email' type="text" {...register("email")}/>
                        </div>
                        <div className="input-container">
                            <input autoComplete='off' placeholder='Password' type={showPassword ? 'text' : 'password'} {...register("password")}/>
                            <Icon className='icon password' icon="mdi:password-outline" />
                            {showPassword
                            ?<Icon onClick={handleShowPassword}  className='icon hide' icon="mdi:hide" />
                            :<Icon onClick={handleShowPassword} className='icon show' icon="mdi:show-outline" />}
                        </div>
                        <p className='link'>Olvidaste tu contraseña?</p>
                        <ButtonWithLoading title='Iniciar Sesión' isLoading={isLoading}/>
                    </form>
                    <p className='footer'>No tienes una cuenta? <span><Link to={REGISTER}>Crear una cuenta</Link></span></p>
                </div>
            </div>

            <div className="side-right">
                <img src={loginImage} alt="" />
                <div className="content">
                    <h2>Herramientas eficientes para ti</h2>
                    <p>Utiliza herramientas diseñadas para optimizar tus sesiones de estudio</p>
                </div>
            </div>
        </div>
    )


}

export default Login


// <Center w="100%" minH="100vh" className='login'>
//             <Box mx="1" maxW="md" p="9">
//                 <Heading mb="4" size="lg" textAlign="center">
//                     Log In
//                 </Heading>

//                 <form onSubmit={handleSubmit(handleLogin)}>
//                     <FormControl isInvalid={errors.email} py="2">
//                         <FormLabel>Email</FormLabel>
//                         <Input
//                             type="email"
//                             placeholder="user@email.com"
//                             focusBorderColor='#17161b'
//                             borderColor="#17161b"
//                             autoComplete='off'
//                             {...register("email", emailValidate)}
//                         />
//                         <FormErrorMessage>
//                             {errors.email && errors.email.message}
//                         </FormErrorMessage>

//                     </FormControl>
//                     <FormControl isInvalid={errors.password} py="2">
//                         <FormLabel>Password</FormLabel>
//                         <Input
//                             type="password"
//                             borderColor="#17161b"
//                             placeholder="password123"
//                             focusBorderColor='#17161b'
//                             {...register("password", passwordValidate)}
//                         />
//                         <FormErrorMessage>
//                             {errors.password && errors.password.message}
//                         </FormErrorMessage>

//                     </FormControl>
//                     <Button
//                         mt="4"
//                         type="submit"
//                         colorScheme="teal"
//                         size="md"
//                         w="full"
//                         loadingText="Logging In"
//                         isLoading={isLoading}
//                     >
//                         Log In
//                     </Button>
//                 </form>

//                 <Text fontSize="xlg" align="center" mt="6">
//                     Don't have an account?{" "}
//                     <Link
//                         as={RouterLink}
//                         to={REGISTER}
//                         color="teal.800"
//                         fontWeight="medium"
//                         textDecor="underline"
//                         _hover={{ color: "teal.100" }}
//                     >
//                         Register
//                     </Link>{" "}
//                     instead!
//                 </Text>
//             </Box>
//         </Center>